import { createSlice } from "@reduxjs/toolkit";
import { withImageGuid } from "@/common/util";

const initialState = {
  orgProfileInfo: null,
  // Logo file name announced by organization.updated that the read side may not
  // serve yet; refetches keep it until they return it themselves.
  pendingProfileImage: null,

  loading: false,
  error: null,
};

const orgProfileSlice = createSlice({
  name: "orgProfile",
  initialState,
  reducers: {
    fetchOrgProfileRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOrgProfileSuccess: (state, action) => {
      state.orgProfileInfo = action.payload.orgProfileData;
      state.loading = false;
    },
    fetchOrgProfileError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateOrgProfileRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    updateOrgProfileSuccess: (state, action) => {
      state.orgProfileInfo = {
        ...state.orgProfileInfo,
        ...action.payload.orgProfileData,
      };
      state.loading = false;
    },
    updateOrgProfileError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateServiceLocationRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    updateServiceLocationSuccess: (state, action) => {
      state.loading = false;
    },
    updateServiceLocationError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    saveSkillset: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    updateSkillsetSuccess: (state, action) => {
      state.OrgSkillsetInfo = action.payload.OrgSkillsetData;
      state.loading = false;
    },
    updateSkillsetError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    orgProfileImageChanged: (state, action) => {
      const guid = action.payload ?? null;
      state.pendingProfileImage = guid;
      if (!guid || !state.orgProfileInfo) return;
      const url = withImageGuid(state.orgProfileInfo.ProfileFullImage, guid);
      if (url) state.orgProfileInfo.ProfileFullImage = url;
    },
    clearPendingProfileImage: (state) => {
      state.pendingProfileImage = null;
    },
  },
});

export const {
  fetchOrgProfileRequest,
  fetchOrgProfileSuccess,
  fetchOrgProfileError,
  updateOrgProfileRequest,
  updateOrgProfileSuccess,
  updateOrgProfileError,
  updateServiceLocationRequest,
  updateServiceLocationSuccess,
  updateServiceLocationError,
  saveSkillset,
  updateSkillsetSuccess,
  updateSkillsetError,
  orgProfileImageChanged,
  clearPendingProfileImage,
} = orgProfileSlice.actions;

export default orgProfileSlice.reducer;
